import { ActionIcon, useMantineTheme } from '@mantine/core';
import { IconPlus } from '@tabler/icons';
import { FC } from 'react';

const NavAddIcon: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ActionIcon
      onClick={onClick}
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.blue[1], to: colors.blue[4], deg: 135 }
          : { from: colors.blue[4], to: colors.blue[0], deg: 135 }
      }
    >
      <IconPlus color="#E5E5E5" />
    </ActionIcon>
  );
};

export default NavAddIcon;
